module.exports = __webpack_public_path__ + "media/images/general/not_setting_thumb_1200_630-f2d85c91cadc1c84e16702a055fc3e29.png";